'use client';

import { useLocalStorage } from 'usehooks-ts';
import { STORAGE_KEYS } from '@/lib/storage-keys';

/** The demo card's element, which the sidebar's demo row reveals; here so the card's file only exports components. */
export const PR_V2_DEMO_CARD_ID = 'pr-v2-demo';

/**
 * Whether demo cards show collapsed, kept in the browser: a viewer who collapses one usually wants
 * the next pull request's out of the way too. Both the card and the sidebar's row change it.
 */
export function usePrV2DemoCollapsed() {
  return useLocalStorage(STORAGE_KEYS.PR_DEMO_COLLAPSED, false);
}